export const GET_ALL_CUE_INFO = 'GET_ALL_CUE_INFO';
export const CUE_ERROR = 'CUE_ERROR';
export const CLEAR_CUE = 'CLEAR_CUE';
